var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlazosImpagados',{attrs:{"plazos":_vm.plazos,"lista_id":_vm.lista_id,"filters":_vm.filters},on:{"actualizado":_vm.getPlazos}})
}
var staticRenderFns = []

export { render, staticRenderFns }